import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import {
	isBatchDownloadRouteMissing,
	readAdminActionError,
	requestAgreementRecalculation,
	saveBatchWorkshopReports
} from './adminActions'

class AdminAgreementTools extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedPsgFileId: '',
			scoringTimes: 1,
			recalculating: false,
			downloading: false
		}
		this.recalculateAllAgreements = this.recalculateAllAgreements.bind(this)
		this.downloadBatchReports = this.downloadBatchReports.bind(this)
	}

	getFiles() {
		return Array.isArray(this.props.files) ? this.props.files : []
	}

	componentDidUpdate(prevProps) {
		if (prevProps.files === this.props.files) return

		const files = this.getFiles()
		const selectionExists = files.some(file =>
			String(file.psgFileId) === this.state.selectedPsgFileId
		)
		if (!selectionExists) {
			this.setState({
				selectedPsgFileId: files.length > 0 ? String(files[0].psgFileId) : ''
			})
		}
	}

	async recalculateAllAgreements() {
		const psgFileId = Number(this.state.selectedPsgFileId)
		if (!Number.isInteger(psgFileId)) return
		if (!window.confirm(
			`確定要重新計算 PSG ${psgFileId} 所有已送出判讀的一致性嗎？\n` +
			'此操作會更新 agreement_result。'
		)) return

		this.setState({ recalculating: true })
		try {
			const result = await requestAgreementRecalculation(psgFileId)
			if (!result.success) {
				alert(result.msg || '批次重算一致性失敗')
				return
			}
			alert(
				`一致性重算完成\n` +
				`更新：${result.updated} 筆\n` +
				`警告：${(result.warnings || []).length} 筆\n` +
				`跳過：${(result.skipped || []).length} 筆\n` +
				`失敗：${(result.failed || []).length} 筆\n` +
				`算法：${result.algorithm}`
			)
		} catch (error) {
			const message = await readAdminActionError(error)
			alert('批次重算一致性失敗：' + message)
		} finally {
			this.setState({ recalculating: false })
		}
	}

	async downloadBatchReports() {
		const psgFileId = Number(this.state.selectedPsgFileId)
		const scoringTimes = this.state.scoringTimes
		if (!Number.isInteger(psgFileId)) return
		if (!window.confirm(
			`確定要從資料庫產生 PSG ${psgFileId} 第 ${scoringTimes} 次所有已完成學員的工作坊報告嗎？\n` +
			'完成名單以 agreement_result 為準；失敗原因會記錄在 summary.csv。'
		)) return

		this.setState({ downloading: true })
		try {
			await saveBatchWorkshopReports(psgFileId, scoringTimes)
		} catch (error) {
			const message = await readAdminActionError(error)
			const routeMissing = error.response && error.response.status === 404 &&
				isBatchDownloadRouteMissing(message)
			alert(routeMissing
				? '批次下載 API 尚未部署到目前連線的後端。\n' +
					'請部署 backend_app.js、backend_workshop_report.js，重新啟動後端服務，並確認 ' +
					'/batch_workshop_reports 可被路由。'
				: '批次下載工作坊報告失敗：' + message)
		} finally {
			this.setState({ downloading: false })
		}
	}

	render() {
		const files = this.getFiles()
		const busy = this.state.recalculating || this.state.downloading
		const hasSelection = this.state.selectedPsgFileId !== ''

		return <section style={{
			maxWidth: '640px',
			margin: '8px auto 24px',
			padding: '16px 20px 20px',
			borderBottom: '1px solid #ced4da'
		}} aria-label="管理工具">
			<h2 style={{ fontSize: '20px', marginBottom: '16px' }}>管理工具</h2>
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-end' }}>
				<Form.Group style={{ flex: '1 1 260px', marginBottom: 0 }} controlId="adminPsgFile">
					<Form.Label>PSG</Form.Label>
					<Form.Control
						as="select"
						value={this.state.selectedPsgFileId}
						disabled={busy || files.length === 0}
						onChange={event => this.setState({ selectedPsgFileId: event.target.value })}>
						{files.length === 0 ? <option value="">沒有可用的 PSG</option> : null}
						{files.map(file => <option key={file.psgFileId} value={file.psgFileId}>
							{file.name}（ID：{file.psgFileId}）
						</option>)}
					</Form.Control>
				</Form.Group>
				<Form.Group style={{ marginBottom: 0 }} controlId="adminScoringTimes">
					<Form.Label style={{ display: 'block' }}>判讀次數</Form.Label>
					<ButtonGroup aria-label="判讀次數">
						{[1, 2].map(times => <Button
							key={times}
							variant={this.state.scoringTimes === times ? 'primary' : 'outline-secondary'}
							disabled={busy}
							onClick={() => this.setState({ scoringTimes: times })}>
							第 {times} 次
						</Button>)}
					</ButtonGroup>
				</Form.Group>
			</div>
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '18px' }}>
				<Button
					variant="warning"
					disabled={busy || !hasSelection}
					onClick={this.recalculateAllAgreements}>
					{this.state.recalculating ? '重算中...' : '重算全部一致性'}
				</Button>
				<Button
					variant="info"
					disabled={busy || !hasSelection}
					onClick={this.downloadBatchReports}>
					{this.state.downloading ? '產生中...' : '批次產生並下載'}
				</Button>
			</div>
		</section>
	}
}

export default AdminAgreementTools
